import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ProfilerService } from './profiler-service';

@Injectable()
export class MiniProfilerInterceptor implements HttpInterceptor {
  constructor(
    private http: HttpClient,
    private profilerService: ProfilerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Fetching a profile costs the API a second request per call, so only users
    // with isPerformanceTrackingEnabled (mirrored into ProfilerService by
    // AppComponent) pay it. The server emits X-MiniProfiler-Ids only when
    // MiniProfiler:Enabled is set, so for everyone else this is a pass-through.
    if (!this.profilerService.trackingEnabled || req.url.includes('profiler')) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            const profilerIdHeader = event.headers.get('X-MiniProfiler-Ids');
            if (profilerIdHeader) {
              const profileId = JSON.parse(profilerIdHeader)[0];
              this.loadProfilerResult(profileId);
            }
          }
        })
      );
    }
  }

  loadProfilerResult(profileId: string) {
    this.http
      .get(`/api/profiler/${profileId}`, {
        withCredentials: true,
      })
      .subscribe((profile: any) => {
        if (!profile.name.includes('GetProfileById')) {
          this.profilerService.profiles.push(profile);

          if (this.profilerService.profiles.length >= 20) {
            this.profilerService.exportProfilesToBlob();
          }
        }
      });
  }
}
